/**
 * NotFound — 404 페이지
 */
import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg px-6 text-center">
      <div>
        <p className="font-serif text-6xl text-gold">404</p>
        <h1 className="mt-4 font-serif text-2xl text-dark">
          페이지를 찾을 수 없습니다
        </h1>
        <p className="mt-3 text-sm text-ink-3">
          요청하신 주소가 변경되었거나 존재하지 않습니다.
        </p>
        <Link to="/" className="btn-gold mt-8 !px-6 !py-3">
          홈으로 돌아가기
        </Link>
      </div>
    </div>
  );
}
